import React, { Component } from 'react';
import { connect } from 'react-redux';
import { startGame, pauseGame, speed_up_Game, slow_down_Game, toggle_sound } from '../actions/UserActions'

class SpeedControl extends Component {

     static propTypes = {
        min: React.PropTypes.number.isRequired,
        max: React.PropTypes.number.isRequired,
        step: React.PropTypes.number.isRequired
    }
    
    constructor(props) {
        super(props);
        this.start_pause_click = this.start_pause_click.bind(this);
        this.speed_up_Game_click = this.speed_up_Game_click.bind(this);
        this.slow_down_Game_click = this.slow_down_Game_click.bind(this);
    }

    start_pause_click(event){
        if(this.props.Paused)
          this.props.dispatch(startGame());
        else
          this.props.dispatch(pauseGame());
    }

    speed_up_Game_click(event){
      if(this.props.GameSpeed > this.props.max)
        this.props.dispatch(speed_up_Game(this.props.step));
    }

    slow_down_Game_click(event){
      if(this.props.GameSpeed  < this.props.min)
        this.props.dispatch(slow_down_Game(this.props.step));
    }

    render() {
        var divStyle = {
            width: (this.props.min - this.props.GameSpeed) / (this.props.min - this.props.max) * 100 + '%'
        }

        return (		<div className="row">		
                            <div className="col-md-2 vcenter">
									<i className={this.props.Muted == true ? "fa fa-volume-off" : "fa fa-volume-up"} onClick={() => this.props.dispatch(toggle_sound())} aria-hidden="true" role="button"></i>
							</div>
                            <div className="col-md-8 vcenter">
                                <i className="fa fa-minus-circle" aria-hidden="true" role="button" onClick={this.slow_down_Game_click}></i>
                                <div className="speedbar"><div className="speedbar-fill" style={divStyle}></div></div>
                                <i className="fa fa-plus-circle" aria-hidden="true" role="button" onClick={this.speed_up_Game_click}></i>
                            </div>
                            <div className="col-md-2 vcenter">
                                <i className={this.props.Paused ? "fa fa-play" : "fa fa-pause"} aria-hidden="true" role="button" onClick={this.start_pause_click}></i>
                            </div>
                        </div>);
    }
}

function mapStateToProps(state, ownProps) {
    return {
        GameSpeed: state.gameSpeed,
        Paused: state.paused,
        CurrentEventNum: state.currentEvent,
        Muted: state.muted
    };
}

export default connect(mapStateToProps)(SpeedControl)



/** WEBPACK FOOTER **
 ** ./src/components/SpeedControl.js
 **/